/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления пользователями
 */

/**
 * Сервис пользователей
 */
export class UserServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения пользователей.
   * Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.
   * Роли owner или employee могут запрашивать только пользователей, принадлежащих их компании
   */
  GetUser = (req: GetUserRequestDto, init?: RequestInit): Promise<GetUserResponseDto> => {
    return fm.request<GetUserRequestDto, GetUserResponseDto>(`${this.host}/user/api/v1/user/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка пользователей.
   * Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.
   * Если метод вызван ролями owner или employee в фильтре поле company_ids принудительно замещается их company_id
   */
  GetUserList = (req?: GetUserListRequestDto, init?: RequestInit): Promise<GetUserListResponseDto[]> => {
    return fm.list<GetUserListRequestDto, GetUserListResponseDto>(`${this.host}/user/api/v1/user/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества пользователей.
   * Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.
   * Если метод вызван ролями owner или employee в фильтре поле company_ids принудительно замещается их company_id
   */
  GetUserCount = (req?: GetUserCountRequestDto, init?: RequestInit): Promise<GetUserCountResponseDto> => {
    return fm.request<GetUserCountRequestDto, GetUserCountResponseDto>(`${this.host}/user/api/v1/user/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления пользователей.
   * Метод доступен для: admin, service
   */
  DeleteUser = (req: DeleteUserRequestDto, init?: RequestInit): Promise<DeleteUserResponseDto> => {
    return fm.request<DeleteUserRequestDto, DeleteUserResponseDto>(`${this.host}/user/api/v1/user/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления всех пользовательских сессий.
   * Метод доступен для: admin, service
   */
  DeleteUserSessions = (req: DeleteUserSessionsRequestDto, init?: RequestInit): Promise<DeleteUserSessionsResponseDto> => {
    return fm.request<DeleteUserSessionsRequestDto, DeleteUserSessionsResponseDto>(`${this.host}/user/api/v1/user/${encodeURIComponent(req.id)}/sessions${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения идентификационного кода пользователя.
   * Метод доступен для: admin, service, ltp_first
   */
  GetUserCode = (req: GetUserCodeRequestDto, init?: RequestInit): Promise<GetUserCodeResponseDto> => {
    return fm.request<GetUserCodeRequestDto, GetUserCodeResponseDto>(`${this.host}/user/api/v1/user/${encodeURIComponent(req.id)}/code${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания идентификационного кода пользователя.
   * После создания кода отправляется событие SendingSmsTask.
   * Метод доступен для: admin, service, ltp_first
   */
  PostUserCodeCreate = (req: PostUserCodeCreateRequestDto, init?: RequestInit): Promise<PostUserCodeCreateResponseDto> => {
    return fm.request<PostUserCodeCreateRequestDto, PostUserCodeCreateResponseDto>(`${this.host}/user/api/v1/user/code/create`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания пользователя.
   * Метод доступен для: admin, service.
   * Доступно создание пользователей с типом: ADMIN, MRF, BTI, LTP_FIRST, SERVICE, DEVICE_ADMIN, MANAGER
   */
  PostUser = (req: PostUserRequestDto, init?: RequestInit): Promise<PostUserResponseDto> => {
    return fm.request<PostUserRequestDto, PostUserResponseDto>(`${this.host}/user/api/v1/user`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов статусов пользователей.
 */
export enum UserStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Не активный пользователь
   */
  NEW = "NEW",
  /**
   * Демо пользователь
   */
  DEMO = "DEMO",
  /**
   * Активный пользователь
   */
  ACTIVE = "ACTIVE",
  /**
   * Архивный пользователь
   */
  BLOCKED = "BLOCKED",
}
/**
 * Справочник типов статусов пользователей.
 */
export type UserStatusTypeResponseEnum = keyof typeof UserStatusType
/**
 * Справочник типов статусов пользователей.
 */
export type UserStatusTypeRequestEnum = Exclude<UserStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов пользователей.
 */
export enum UserType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Владелец УК
   */
  OWNER = "OWNER",
  /**
   * Сотрудник УК
   */
  EMPLOYEE = "EMPLOYEE",
  /**
   * Мастер житель
   */
  MASTER = "MASTER",
  /**
   * Подчиненный житель
   */
  SLAVE = "SLAVE",
  /**
   * Администратор
   */
  ADMIN = "ADMIN",
  /**
   * Сотрудники ГАП
   */
  SELLER = "SELLER",
  /**
   * МРФ
   */
  MRF = "MRF",
  /**
   * ГРЗУК
   */
  BACKOFFICE = "BACKOFFICE",
  /**
   * Сервис
   */
  SERVICE = "SERVICE",
  /**
   * Супер админ
   */
  ROOT = "ROOT",
  /**
   * Сотрудник БТИ
   */
  BTI = "BTI",
  /**
   * Сотрудник 1 ЛТП
   */
  LTP_FIRST = "LTP_FIRST",
  /**
   * Сотрудник ГАП
   */
  EXTERNAL_SELLER = "EXTERNAL_SELLER",
  /**
   * Приложение
   */
  APPLICATION = "APPLICATION",
  /**
   * Администратор точек продаж
   */
  MANAGER = "MANAGER",
  /**
   * Администратор устройств
   */
  DEVICE_ADMIN = "DEVICE_ADMIN",
}
/**
 * Справочник типов пользователей.
 */
export type UserTypeResponseEnum = keyof typeof UserType
/**
 * Справочник типов пользователей.
 */
export type UserTypeRequestEnum = Exclude<UserTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum UserPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type UserPagingDirectionTypeResponseEnum = keyof typeof UserPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type UserPagingDirectionTypeRequestEnum = Exclude<UserPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum UserPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По электронной почте
   */
  EMAIL = "EMAIL",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
  /**
   * По описанию (collate-agnostic ordering)
   */
  DESCRIPTION = "DESCRIPTION",
}
/**
 * Справочник типов значений сортировки.
 */
export type UserPagingOrderByTypeResponseEnum = keyof typeof UserPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type UserPagingOrderByTypeRequestEnum = Exclude<UserPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления пользователя
 */
export type DeleteUserRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления пользователя
 */
export type DeleteUserResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteUserResponseErrorDto
}>
/**
 * Ошибка запроса удаления пользователя
 */
export type DeleteUserResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: UserSavingErrorRequestDto
}>
/**
 * Ошибка запроса удаления пользователя
 */
export type DeleteUserResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: UserSavingErrorResponseDto
}>
/**
 * Запрос удаления всех пользовательских сессий
 */
export type DeleteUserSessionsRequestDto = {
  /**
   * Идентификатор пользователя.
   * # Диапазон: 1..2147483647
   */
  id: number
}
/**
 * Ответ на запрос удаления всех пользовательских сессий
 */
export type DeleteUserSessionsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteUserSessionsResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteUserSessionsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteUserSessionsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения идентификационного кода пользователя
 */
export type GetUserCodeRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
}
/**
 * Ответ на запрос получения идентификационного кода пользователя
 */
export type GetUserCodeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Идентификационный код
   */
  readonly data: UserCodeResponseDto
  /**
   * Ошибка
   */
  readonly error: GetUserCodeResponseErrorDto
}>
/**
 * Ошибка запроса получения идентификационного кода пользователя
 */
export type GetUserCodeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * У пользователя отсутствует идентификационный код
   */
  readonly userCodeNotFound: GetUserCodeResponseErrorUserCodeNotFoundRequestDto
}>
/**
 * Ошибка запроса получения идентификационного кода пользователя
 */
export type GetUserCodeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * У пользователя отсутствует идентификационный код
   */
  readonly userCodeNotFound: GetUserCodeResponseErrorUserCodeNotFoundDto
}>
/**
 * У пользователя отсутствует идентификационный код
 */
export type GetUserCodeResponseErrorUserCodeNotFoundRequestDto = {
}
/**
 * У пользователя отсутствует идентификационный код
 */
export type GetUserCodeResponseErrorUserCodeNotFoundDto = {
}
/**
 * Запрос получения количества пользователей
 */
export type GetUserCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: UserFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества пользователей
 */
export type GetUserCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего пользователей
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetUserCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества пользователей
 */
export type GetUserCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества пользователей
 */
export type GetUserCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка пользователей
 */
export type GetUserListRequestDto = {
  /**
   * Фильтр
   */
  filter?: UserFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: UserPagingRequestDto
}>
/**
 * Ответ на получение списка пользователей
 */
export type GetUserListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пользователь
   */
  readonly data: UserResponseDto
  /**
   * Ошибка
   */
  readonly error: GetUserListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка пользователей
 */
export type GetUserListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка пользователей
 */
export type GetUserListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения пользователя
 */
export type GetUserRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения пользователя
 */
export type GetUserResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пользователь
   */
  readonly data: UserResponseDto
  /**
   * Ошибка
   */
  readonly error: GetUserResponseErrorDto
}>
/**
 * Ошибка запроса получения пользователя
 */
export type GetUserResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения пользователя
 */
export type GetUserResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос создания идентификационного кода пользователя
 */
export type PostUserCodeCreateRequestDto = {
  /**
   * Идентификационный код пользователя
   */
  userCode: UserCodeRequestDto
}
/**
 * Ответ на запрос создания идентификационного кода пользователя
 */
export type PostUserCodeCreateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Идентификационный код пользователя
   */
  readonly data: UserCodeResponseDto
  /**
   * Ошибка
   */
  readonly error: PostUserCodeCreateResponseErrorDto
}>
/**
 * Ошибка запроса создания идентификационного кода пользователя
 */
export type PostUserCodeCreateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса создания идентификационного кода пользователя
 */
export type PostUserCodeCreateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на создание пользователя
 */
export type PostUserRequestDto = {
  /**
   * Пользователь
   */
  data: UserRequestDto
}
/**
 * Ответ на запрос на создание пользователя
 */
export type PostUserResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пользователь
   */
  readonly data: UserResponseDto
  /**
   * Ошибка
   */
  readonly error: PostUserResponseErrorDto
}>
/**
 * Ошибка запроса сохранения пользователя
 */
export type PostUserResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: UserSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения пользователя
 */
export type PostUserResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: UserSavingErrorResponseDto
}>
/**
 * Пользователь
 */
export type UserRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Тип пользователя
   */
  type: UserTypeRequestEnum
  /**
   * Логин.
   * # Диапазон: 3..64
   */
  login?: string | null
  /**
   * Электронная почта.
   * # Диапазон: 4..256
   */
  email?: string | null
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phoneNumber?: string | null
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  companyId?: number | null
  /**
   * Идентификатор МРФ
   */
  mrfId?: number | null
  /**
   * Идентификатор РФ
   */
  rfId?: number | null
  /**
   * Дата изменения.
   * # Тип: DateTime
   */
  changedAt?: string | null
  /**
   * Идентификатор пользователя-владельца.
   * # Диапазон: 1..2147483647
   */
  ownerUserId?: number | null
  /**
   * Электронная почта для чеков.
   * # Диапазон: 4..256
   */
  invoiceEmail?: string | null
  /**
   * Описание
   */
  description?: string | null
  /**
   * Адрес окружения для внутренних пользователей
   */
  envUrl?: string | null
}
/**
 * Пользователь
 */
export type UserResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Тип пользователя
   */
  type: UserTypeResponseEnum
  /**
   * Статус пользователя
   */
  readonly statusType: UserStatusTypeResponseEnum
  /**
   * Логин.
   * # Диапазон: 3..64
   */
  login: string | null
  /**
   * Электронная почта.
   * # Диапазон: 4..256
   */
  email: string | null
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phoneNumber: string | null
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  companyId: number | null
  /**
   * Идентификатор МРФ
   */
  mrfId: number | null
  /**
   * Идентификатор РФ
   */
  rfId: number | null
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата изменения.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата активации.
   * # Тип: DateTime
   */
  readonly activatedAt: string | null
  /**
   * Дата активации.
   * # Тип: DateTime
   */
  readonly blockedAt: string | null
  /**
   * Идентификатор создавшего пользователя.
   * Берется из токена.
   * # Диапазон: 1..2147483647
   */
  readonly creatorUserId: number | null
  /**
   * Идентификатор пользователя-владельца.
   * # Диапазон: 1..2147483647
   */
  ownerUserId: number | null
  /**
   * Электронная почта для чеков.
   * # Диапазон: 4..256
   */
  invoiceEmail: string | null
  /**
   * Идентификатор пользователя в Видеонаблюдении.
   * Вычисляется на стороне сервера при создании пользователя
   */
  readonly vcUserId: number | null
  /**
   * Описание
   */
  description: string | null
  /**
   * Идентификатор пользователя в сервисе ustore.
   * Вычисляется на стороне сервера при создании пользователя
   */
  readonly ustoreUserId: number | null
  /**
   * Адрес окружения для внутренних пользователей
   */
  envUrl: string | null
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type UserSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: UserSavingErrorConflictRequestDto
  /**
   * Нельзя удалять пользователя с данным типом
   */
  readonly userTypeForbidden: UserSavingErrorUserTypeForbiddenRequestDto
  /**
   * Нельзя удалять пользователя в текущем статусе
   */
  readonly userStatusForbidden: UserSavingErrorUserStatusForbiddenRequestDto
  /**
   * Идентификатор МРФ обязателен
   */
  readonly mrfIdIsRequiredForUserType: UserSavingErrorMrfIdRequiredForUserTypeRequestDto
  /**
   * Создатель пользователя должен иметь роль Admin
   */
  readonly creatorMustBeAdmin: UserSavingErrorCreatorMustBeAdminRequestDto
  /**
   * Идентификатор РФ не соответствует идентификатору МРФ
   */
  readonly rfIdDoesNotMatchMrfId: UserSavingErrorRfIdDoesNotMatchMrfIdRequestDto
  /**
   * Email уже занят
   */
  readonly emailIsAlreadyTaken: UserSavingErrorEmailIsAlreadyTakenRequestDto
  /**
   * Связанная с пользователем сущность не найдена
   */
  readonly entityNotFound: UserSavingErrorEntityNotFoundRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type UserSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: UserSavingErrorConflictResponseDto
  /**
   * Нельзя удалять пользователя с данным типом
   */
  readonly userTypeForbidden: UserSavingErrorUserTypeForbiddenResponseDto
  /**
   * Нельзя удалять пользователя в текущем статусе
   */
  readonly userStatusForbidden: UserSavingErrorUserStatusForbiddenResponseDto
  /**
   * Идентификатор МРФ обязателен
   */
  readonly mrfIdIsRequiredForUserType: UserSavingErrorMrfIdRequiredForUserTypeResponseDto
  /**
   * Создатель пользователя должен иметь роль Admin
   */
  readonly creatorMustBeAdmin: UserSavingErrorCreatorMustBeAdminResponseDto
  /**
   * Идентификатор РФ не соответствует идентификатору МРФ
   */
  readonly rfIdDoesNotMatchMrfId: UserSavingErrorRfIdDoesNotMatchMrfIdResponseDto
  /**
   * Email уже занят
   */
  readonly emailIsAlreadyTaken: UserSavingErrorEmailIsAlreadyTakenResponseDto
  /**
   * Связанная с пользователем сущность не найдена
   */
  readonly entityNotFound: UserSavingErrorEntityNotFoundResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type UserSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type UserSavingErrorConflictResponseDto = {
}
/**
 * Создатель пользователя должен иметь роль Admin
 */
export type UserSavingErrorCreatorMustBeAdminRequestDto = {
}
/**
 * Создатель пользователя должен иметь роль Admin
 */
export type UserSavingErrorCreatorMustBeAdminResponseDto = {
}
/**
 * Email уже занят
 */
export type UserSavingErrorEmailIsAlreadyTakenRequestDto = {
}
/**
 * Email уже занят
 */
export type UserSavingErrorEmailIsAlreadyTakenResponseDto = {
}
/**
 * Связанная с пользователем сущность не найдена.
 * Например: компания по company_id, пользователь по owner_user_id
 */
export type UserSavingErrorEntityNotFoundRequestDto = {
  /**
   * Поле
   */
  field?: string
}
/**
 * Связанная с пользователем сущность не найдена.
 * Например: компания по company_id, пользователь по owner_user_id
 */
export type UserSavingErrorEntityNotFoundResponseDto = {
  /**
   * Поле
   */
  field: string
}
/**
 * Для данного типа пользователя идентификатор МРФ обязателен
 */
export type UserSavingErrorMrfIdRequiredForUserTypeRequestDto = {
}
/**
 * Для данного типа пользователя идентификатор МРФ обязателен
 */
export type UserSavingErrorMrfIdRequiredForUserTypeResponseDto = {
}
/**
 * Идентификатор РФ не соответствует идентификатору МРФ
 */
export type UserSavingErrorRfIdDoesNotMatchMrfIdRequestDto = {
}
/**
 * Идентификатор РФ не соответствует идентификатору МРФ
 */
export type UserSavingErrorRfIdDoesNotMatchMrfIdResponseDto = {
}
/**
 * Нельзя удалять пользователя в текущем статусе.
 * В каких статусах можно удалить пользователя:
 * - demo
 */
export type UserSavingErrorUserStatusForbiddenRequestDto = {
}
/**
 * Нельзя удалять пользователя в текущем статусе.
 * В каких статусах можно удалить пользователя:
 * - demo
 */
export type UserSavingErrorUserStatusForbiddenResponseDto = {
}
/**
 * Нельзя удалять пользователя с данным типом.
 * Доступные типы:
 * - Жилец (мастер)
 */
export type UserSavingErrorUserTypeForbiddenRequestDto = {
}
/**
 * Нельзя удалять пользователя с данным типом.
 * Доступные типы:
 * - Жилец (мастер)
 */
export type UserSavingErrorUserTypeForbiddenResponseDto = {
}
/**
 * Идентификационный код пользователя
 */
export type UserCodeRequestDto = {
  /**
   * Идентификационный код.
   * Если поле не заполнено, генерируется автоматически.
   * # Диапазон: 10000..99999
   */
  code?: number
  /**
   * Идентификатор пользователя.
   * # Диапазон: 0..2147483647
   */
  userId: number
}
/**
 * Идентификационный код пользователя
 */
export type UserCodeResponseDto = {
  /**
   * Идентификационный код.
   * Если поле не заполнено, генерируется автоматически.
   * # Диапазон: 10000..99999
   */
  code: number
  /**
   * Идентификатор пользователя.
   * # Диапазон: 0..2147483647
   */
  userId: number
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Идентификатор создателя кода
   */
  readonly creatorUserId: number
  /**
   * Тип создателя кода
   */
  readonly creatorUserType: UserTypeResponseEnum
}
/**
 * Фильтр по пользователям
 */
export type UserFilterRequestDto = {
  /**
   * По идентификаторам компаний
   */
  companyIds?: number[]
  /**
   * По типам
   */
  userTypes?: UserTypeResponseEnum[]
  /**
   * По статусам
   */
  userStatusTypes?: UserStatusTypeResponseEnum[]
  /**
   * По электронной почте
   */
  emails?: string[]
  /**
   * По номеру телефона
   */
  phoneNumbers?: string[]
  /**
   * По логину
   */
  logins?: string[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Описание
   */
  text?: string | null
  /**
   * Поиск по контактным данным пользователя (электронная почта или номер телефона).
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Электронная почта;
   * # - Номер телефона
   */
  contacts?: string | null
}
/**
 * Фильтр по пользователям
 */
export type UserFilterResponseDto = {
  /**
   * По идентификаторам компаний
   */
  companyIds: number[]
  /**
   * По типам
   */
  userTypes: UserTypeResponseEnum[]
  /**
   * По статусам
   */
  userStatusTypes: UserStatusTypeResponseEnum[]
  /**
   * По электронной почте
   */
  emails: string[]
  /**
   * По номеру телефона
   */
  phoneNumbers: string[]
  /**
   * По логину
   */
  logins: string[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Описание
   */
  text: string | null
  /**
   * Поиск по контактным данным пользователя (электронная почта или номер телефона).
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Электронная почта;
   * # - Номер телефона
   */
  contacts: string | null
}
/**
 * Постраничный вывод
 */
export type UserPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: UserPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: UserPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type UserPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: UserPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: UserPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления пользователя
   */
  "DeleteUserRequest": {
    "kind": "class",
    "text": "Запрос удаления пользователя",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления пользователя
   */
  "DeleteUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления пользователя",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteUserResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления пользователя
   */
  "DeleteUserResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления пользователя",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "User.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос удаления всех пользовательских сессий
   */
  "DeleteUserSessionsRequest": {
    "kind": "class",
    "text": "Запрос удаления всех пользовательских сессий",
    "fields": {
      /**
       * Идентификатор пользователя.
       * # Диапазон: 1..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор пользователя.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления всех пользовательских сессий
   */
  "DeleteUserSessionsResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления всех пользовательских сессий",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteUserSessionsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteUserSessionsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения идентификационного кода пользователя
   */
  "GetUserCodeRequest": {
    "kind": "class",
    "text": "Запрос получения идентификационного кода пользователя",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос получения идентификационного кода пользователя
   */
  "GetUserCodeResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения идентификационного кода пользователя",
    "fields": {
      /**
       * Идентификационный код
       */
      "data": {
        "type": "UserCode",
        "text": "Идентификационный код",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetUserCodeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения идентификационного кода пользователя
   */
  "GetUserCodeResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения идентификационного кода пользователя",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * У пользователя отсутствует идентификационный код
       */
      "userCodeNotFound": {
        "type": "GetUserCodeResponse.Error.UserCodeNotFound",
        "text": "У пользователя отсутствует идентификационный код",
      },
    },
  },
  /**
   * У пользователя отсутствует идентификационный код
   */
  "GetUserCodeResponse.Error.UserCodeNotFound": {
    "kind": "class",
    "text": "У пользователя отсутствует идентификационный код",
  },
  /**
   * Запрос получения количества пользователей
   */
  "GetUserCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества пользователей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "UserFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества пользователей
   */
  "GetUserCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества пользователей",
    "fields": {
      /**
       * Всего пользователей
       */
      "data": {
        "type": "int32",
        "text": "Всего пользователей",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetUserCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества пользователей
   */
  "GetUserCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества пользователей",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка пользователей
   */
  "GetUserListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка пользователей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "UserFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "UserPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка пользователей
   */
  "GetUserListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка пользователей",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetUserListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка пользователей
   */
  "GetUserListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка пользователей",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения пользователя
   */
  "GetUserRequest": {
    "kind": "class",
    "text": "Запрос получения пользователя",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения пользователя
   */
  "GetUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения пользователя",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetUserResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения пользователя
   */
  "GetUserResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения пользователя",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания идентификационного кода пользователя
   */
  "PostUserCodeCreateRequest": {
    "kind": "class",
    "text": "Запрос создания идентификационного кода пользователя",
    "fields": {
      /**
       * Идентификационный код пользователя
       */
      "userCode": {
        "type": "UserCode",
        "text": "Идентификационный код пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания идентификационного кода пользователя
   */
  "PostUserCodeCreateResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания идентификационного кода пользователя",
    "fields": {
      /**
       * Идентификационный код пользователя
       */
      "data": {
        "type": "UserCode",
        "text": "Идентификационный код пользователя",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostUserCodeCreateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса создания идентификационного кода пользователя
   */
  "PostUserCodeCreateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса создания идентификационного кода пользователя",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на создание пользователя
   */
  "PostUserRequest": {
    "kind": "class",
    "text": "Запрос на создание пользователя",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание пользователя
   */
  "PostUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание пользователя",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostUserResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения пользователя
   */
  "PostUserResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения пользователя",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "User.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Пользователь
   */
  "User": {
    "kind": "class",
    "text": "Пользователь",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип пользователя
       */
      "type": {
        "type": "User.Type",
        "text": "Тип пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус пользователя
       */
      "statusType": {
        "type": "User.StatusType",
        "text": "Статус пользователя",
      },
      /**
       * Логин.
       * # Диапазон: 3..64
       */
      "login": {
        "type": "google.protobuf.StringValue",
        "text": "Логин.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Электронная почта.
       * # Диапазон: 4..256
       */
      "email": {
        "type": "google.protobuf.StringValue",
        "text": "Электронная почта.\n# Диапазон: 4..256",
        "rules": {
          "minLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Минимум: 4"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Номер телефона.
       * # Диапазон: 5..14
       */
      "phoneNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Номер телефона.\n# Диапазон: 5..14",
        "rules": {
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Идентификатор компании.
       * # Диапазон: 1..2147483647
       */
      "companyId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор компании.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор МРФ
       */
      "mrfId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор МРФ",
      },
      /**
       * Идентификатор РФ
       */
      "rfId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор РФ",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата изменения.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата изменения.\n# Тип: DateTime",
      },
      /**
       * Дата активации.
       * # Тип: DateTime
       */
      "activatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата активации.\n# Тип: DateTime",
      },
      /**
       * Дата активации.
       * # Тип: DateTime
       */
      "blockedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата активации.\n# Тип: DateTime",
      },
      /**
       * Идентификатор создавшего пользователя.
       * Берется из токена.
       * # Диапазон: 1..2147483647
       */
      "creatorUserId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор создавшего пользователя.\nБерется из токена.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор пользователя-владельца.
       * # Диапазон: 1..2147483647
       */
      "ownerUserId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя-владельца.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Электронная почта для чеков.
       * # Диапазон: 4..256
       */
      "invoiceEmail": {
        "type": "google.protobuf.StringValue",
        "text": "Электронная почта для чеков.\n# Диапазон: 4..256",
        "rules": {
          "minLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Минимум: 4"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Идентификатор пользователя в Видеонаблюдении.
       * Вычисляется на стороне сервера при создании пользователя
       */
      "vcUserId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя в Видеонаблюдении.\nВычисляется на стороне сервера при создании пользователя",
      },
      /**
       * Описание
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание",
      },
      /**
       * Идентификатор пользователя в сервисе ustore.
       * Вычисляется на стороне сервера при создании пользователя
       */
      "ustoreUserId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор пользователя в сервисе ustore.\nВычисляется на стороне сервера при создании пользователя",
      },
      /**
       * Адрес окружения для внутренних пользователей
       */
      "envUrl": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес окружения для внутренних пользователей",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "User.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "User.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Нельзя удалять пользователя с данным типом
       */
      "userTypeForbidden": {
        "type": "User.SavingError.UserTypeForbidden",
        "text": "Нельзя удалять пользователя с данным типом",
      },
      /**
       * Нельзя удалять пользователя в текущем статусе
       */
      "userStatusForbidden": {
        "type": "User.SavingError.UserStatusForbidden",
        "text": "Нельзя удалять пользователя в текущем статусе",
      },
      /**
       * Идентификатор МРФ обязателен
       */
      "mrfIdIsRequiredForUserType": {
        "type": "User.SavingError.MrfIdRequiredForUserType",
        "text": "Идентификатор МРФ обязателен",
      },
      /**
       * Создатель пользователя должен иметь роль Admin
       */
      "creatorMustBeAdmin": {
        "type": "User.SavingError.CreatorMustBeAdmin",
        "text": "Создатель пользователя должен иметь роль Admin",
      },
      /**
       * Идентификатор РФ не соответствует идентификатору МРФ
       */
      "rfIdDoesNotMatchMrfId": {
        "type": "User.SavingError.RfIdDoesNotMatchMrfId",
        "text": "Идентификатор РФ не соответствует идентификатору МРФ",
      },
      /**
       * Email уже занят
       */
      "emailIsAlreadyTaken": {
        "type": "User.SavingError.EmailIsAlreadyTaken",
        "text": "Email уже занят",
      },
      /**
       * Связанная с пользователем сущность не найдена
       */
      "entityNotFound": {
        "type": "User.SavingError.EntityNotFound",
        "text": "Связанная с пользователем сущность не найдена",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "User.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Создатель пользователя должен иметь роль Admin
   */
  "User.SavingError.CreatorMustBeAdmin": {
    "kind": "class",
    "text": "Создатель пользователя должен иметь роль Admin",
  },
  /**
   * Email уже занят
   */
  "User.SavingError.EmailIsAlreadyTaken": {
    "kind": "class",
    "text": "Email уже занят",
  },
  /**
   * Связанная с пользователем сущность не найдена.
   * Например: компания по company_id, пользователь по owner_user_id
   */
  "User.SavingError.EntityNotFound": {
    "kind": "class",
    "text": "Связанная с пользователем сущность не найдена.\nНапример: компания по company_id, пользователь по owner_user_id",
    "fields": {
      /**
       * Поле
       */
      "field": {
        "type": "string",
        "text": "Поле",
      },
    },
  },
  /**
   * Для данного типа пользователя идентификатор МРФ обязателен
   */
  "User.SavingError.MrfIdRequiredForUserType": {
    "kind": "class",
    "text": "Для данного типа пользователя идентификатор МРФ обязателен",
  },
  /**
   * Идентификатор РФ не соответствует идентификатору МРФ
   */
  "User.SavingError.RfIdDoesNotMatchMrfId": {
    "kind": "class",
    "text": "Идентификатор РФ не соответствует идентификатору МРФ",
  },
  /**
   * Нельзя удалять пользователя в текущем статусе.
   * В каких статусах можно удалить пользователя:
   * - demo
   */
  "User.SavingError.UserStatusForbidden": {
    "kind": "class",
    "text": "Нельзя удалять пользователя в текущем статусе.\nВ каких статусах можно удалить пользователя:\n- demo",
  },
  /**
   * Нельзя удалять пользователя с данным типом.
   * Доступные типы:
   * - Жилец (мастер)
   */
  "User.SavingError.UserTypeForbidden": {
    "kind": "class",
    "text": "Нельзя удалять пользователя с данным типом.\nДоступные типы:\n- Жилец (мастер)",
  },
  /**
   * Идентификационный код пользователя
   */
  "UserCode": {
    "kind": "class",
    "text": "Идентификационный код пользователя",
    "fields": {
      /**
       * Идентификационный код.
       * Если поле не заполнено, генерируется автоматически.
       * # Диапазон: 10000..99999
       */
      "code": {
        "type": "int32",
        "text": "Идентификационный код.\nЕсли поле не заполнено, генерируется автоматически.\n# Диапазон: 10000..99999",
        "rules": {
          "min": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Минимум: 10000"
          },
          "max": {
            "value": 99999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 99999"
          },
        }
      },
      /**
       * Идентификатор пользователя.
       * # Диапазон: 0..2147483647
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Идентификатор создателя кода
       */
      "creatorUserId": {
        "type": "int32",
        "text": "Идентификатор создателя кода",
      },
      /**
       * Тип создателя кода
       */
      "creatorUserType": {
        "type": "User.Type",
        "text": "Тип создателя кода",
      },
    },
  },
  /**
   * Фильтр по пользователям
   */
  "UserFilter": {
    "kind": "class",
    "text": "Фильтр по пользователям",
    "fields": {
      /**
       * По идентификаторам компаний
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний",
      },
      /**
       * По типам
       */
      "userTypes": {
        "type": "User.Type",
        "text": "По типам",
      },
      /**
       * По статусам
       */
      "userStatusTypes": {
        "type": "User.StatusType",
        "text": "По статусам",
      },
      /**
       * По электронной почте
       */
      "emails": {
        "type": "string",
        "text": "По электронной почте",
      },
      /**
       * По номеру телефона
       */
      "phoneNumbers": {
        "type": "string",
        "text": "По номеру телефона",
      },
      /**
       * По логину
       */
      "logins": {
        "type": "string",
        "text": "По логину",
      },
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Поиск по контактным данным пользователя (электронная почта или номер телефона).
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Электронная почта;
       * # - Номер телефона
       */
      "contacts": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по контактным данным пользователя (электронная почта или номер телефона).\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Электронная почта;\n# - Номер телефона",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "UserPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "UserPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "UserPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов статусов пользователей.
   */
  "User.StatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов пользователей.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Не активный пользователь
       */
      "NEW": {
        "i": 1,
        "text": "Не активный пользователь",
      },
      /**
       * Демо пользователь
       */
      "DEMO": {
        "i": 2,
        "text": "Демо пользователь",
      },
      /**
       * Активный пользователь
       */
      "ACTIVE": {
        "i": 3,
        "text": "Активный пользователь",
      },
      /**
       * Архивный пользователь
       */
      "BLOCKED": {
        "i": 4,
        "text": "Архивный пользователь",
      },
    },
  },
  /**
   * Справочник типов пользователей.
   */
  "User.Type": {
    "kind": "enum",
    "text": "Справочник типов пользователей.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Владелец УК
       */
      "OWNER": {
        "i": 1,
        "text": "Владелец УК",
      },
      /**
       * Сотрудник УК
       */
      "EMPLOYEE": {
        "i": 2,
        "text": "Сотрудник УК",
      },
      /**
       * Мастер житель
       */
      "MASTER": {
        "i": 3,
        "text": "Мастер житель",
      },
      /**
       * Подчиненный житель
       */
      "SLAVE": {
        "i": 4,
        "text": "Подчиненный житель",
      },
      /**
       * Администратор
       */
      "ADMIN": {
        "i": 5,
        "text": "Администратор",
      },
      /**
       * Сотрудники ГАП
       */
      "SELLER": {
        "i": 6,
        "text": "Сотрудники ГАП",
      },
      /**
       * МРФ
       */
      "MRF": {
        "i": 7,
        "text": "МРФ",
      },
      /**
       * ГРЗУК
       */
      "BACKOFFICE": {
        "i": 8,
        "text": "ГРЗУК",
      },
      /**
       * Сервис
       */
      "SERVICE": {
        "i": 9,
        "text": "Сервис",
      },
      /**
       * Супер админ
       */
      "ROOT": {
        "i": 10,
        "text": "Супер админ",
      },
      /**
       * Сотрудник БТИ
       */
      "BTI": {
        "i": 11,
        "text": "Сотрудник БТИ",
      },
      /**
       * Сотрудник 1 ЛТП
       */
      "LTP_FIRST": {
        "i": 12,
        "text": "Сотрудник 1 ЛТП",
      },
      /**
       * Сотрудник ГАП
       */
      "EXTERNAL_SELLER": {
        "i": 13,
        "text": "Сотрудник ГАП",
      },
      /**
       * Приложение
       */
      "APPLICATION": {
        "i": 14,
        "text": "Приложение",
      },
      /**
       * Администратор точек продаж
       */
      "MANAGER": {
        "i": 15,
        "text": "Администратор точек продаж",
      },
      /**
       * Администратор устройств
       */
      "DEVICE_ADMIN": {
        "i": 16,
        "text": "Администратор устройств",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "UserPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "UserPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "По времени изменения",
      },
      /**
       * По электронной почте
       */
      "EMAIL": {
        "i": 4,
        "text": "По электронной почте",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 5,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
      /**
       * По описанию (collate-agnostic ordering)
       */
      "DESCRIPTION": {
        "i": 6,
        "text": "По описанию (collate-agnostic ordering)",
      },
    },
  },
}